import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../../common/types';
import styles from './PricingButton.module.scss';

export interface PricingButtonProps {
  variant: 'primary' | 'ghost';
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
}

const PricingButtonComponent: React.FC<PricingButtonProps> = ({ variant, onClick, disabled, className, children }) => (
  <button
    type="button"
    className={clsx(styles.btn, variant === 'primary' ? styles.btnPrimary : styles.btnGhost, className)}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </button>
);

export const PricingButton = TypedMemo(PricingButtonComponent);
